import { render, staticRenderFns } from "./MbInfo.vue?vue&type=template&id=25c9cbae&scoped=true&"
import script from "./MbInfo.vue?vue&type=script&lang=js&"
export * from "./MbInfo.vue?vue&type=script&lang=js&"
import style0 from "./MbInfo.vue?vue&type=style&index=0&id=25c9cbae&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c9cbae",
  null
  
)

export default component.exports